export default __webpack_public_path__ + "static/media/pomodoro-mobile.98336f61.jpg";